// let host = '';
// let imgHost = '';
// if (process.env.NODE_ENV === 'production') {
//   host = 'https://nongji-web.ahnydsj.com/nongji-web/';
//   imgHost = 'https://nongji-img.ahnydsj.com/app2/img-upload/';
// } else {
const host = "https://nongji-web.ahnydsj.com/nongji-web";
const imgHost = "https://nongji-img.ahnydsj.com/app2/img-upload/";
// }
// host = 'https://nongji-api.ahnydsj.com/nongji-api/';
// imgHost = 'https://nongji-img.ahnydsj.com/app2/img-upload/';

console.log(process.env.NODE_ENV);
export { host, imgHost };



// WEBPACK FOOTER //
// ./src/api/config.js